import {
  ExpenseError,
  ExpenseResponse,
  ExpensesTypeResponse,
  ExpensesPayload,
  ApproveExpensePayload,
  ExpenseCommonResponse,
  EditExpensePayload,
  EditExpenseResponse,
  AddCommentPayload,
} from '@core/interface/expense';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ExpenseActions = createActionGroup({
  source: 'Expense',
  events: {
    'Load Expenses': props<ExpensesPayload>(),
    'Load Expenses Success': props<ExpenseResponse>(),
    'Load Expenses Failure': props<ExpenseError>(),
    'Load Expenses Types': emptyProps(),
    'Load Expenses Types Success': props<ExpensesTypeResponse>(),
    'Load Expenses Types Failure': props<ExpenseError>(),
    'Approve Expenses': props<ApproveExpensePayload>(),
    'Approve Expenses Success': props<ExpenseCommonResponse>(),
    'Approve Expenses Failure': props<ExpenseError>(),
    'reset Approve Expenses': emptyProps(),
    'Edit Expense ': props< { ExpenseDetails :EditExpensePayload;}>(),
    'Edit Expense Success': props<EditExpenseResponse>(),
    'Edit Expense Failure': props<ExpenseError>(),
    'Add Comment': props<AddCommentPayload>(),
    'Add Comment Success': props<EditExpenseResponse>(),
    'Add Comment Failure': props<ExpenseError>(),
    'Admin Direct Approve': props<{ ids: string }>(),
    'Admin Direct Approve Success': props<ExpenseCommonResponse>(),
    'Admin Direct Approve Failure': props<ExpenseError>(),
  },
});
